import { supabase } from "../lib/supabase";

const API_BASE = process.env.REACT_APP_API_BASE || "";

async function authHeaders() {
  const {
    data: { session },
  } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) {
    throw new Error("Bitte melde dich an, um den Einladungslink zu teilen.");
  }
  return {
    Authorization: `Bearer ${token}`,
  };
}

function deviceTimezone() {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "Europe/Zurich";
  } catch {
    return "Europe/Zurich";
  }
}

/**
 * Get-or-create reusable invite link for the current user.
 * @returns {Promise<{ token: string, inviterFirstName: string, path: string }>}
 */
export async function fetchMyInviteLink() {
  const res = await fetch(`${API_BASE}/api/briefing-invites/mine`, {
    headers: await authHeaders(),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Einladungslink konnte nicht geladen werden.");
  }
  return res.json();
}

/**
 * Public landing payload for /einladung/:token.
 * @param {string} token
 */
export async function fetchInviteLanding(token) {
  const res = await fetch(`${API_BASE}/api/briefing-invites/${encodeURIComponent(token)}`);
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    const error = new Error(err.error || "Einladung konnte nicht geladen werden.");
    error.status = res.status;
    throw error;
  }
  return res.json();
}

/**
 * Accept invite: enable briefing for acceptor and notify inviter.
 * @param {string} token
 */
export async function acceptBriefingInvite(token) {
  const res = await fetch(`${API_BASE}/api/briefing-invites/accept`, {
    method: "POST",
    headers: {
      ...(await authHeaders()),
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ token, timezone: deviceTimezone() }),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || "Aktivierung fehlgeschlagen.");
  }
  return res.json();
}

/** Absolute invite URL for WhatsApp share. */
export function inviteAbsoluteUrl(path) {
  const base =
    typeof window !== "undefined" ? window.location.origin : "https://albis.life";
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}
